/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import styles from './styles';

const useStyles = makeStyles(styles);

interface Props {
  value: number | null;
  isEnv?: boolean;
  isCapacity?: boolean;
}

const PercentIndicator = ({ value, isEnv, isCapacity }: Props) => {
  const classes = useStyles();

  const clamp = (n?: number | string | null) =>
    Math.max(0, Math.min(100, Number(n ?? 0)));

  const usePercentColor = (
    value: number,
    classesRef: ReturnType<typeof useStyles>,
    capacity?: boolean
  ) => {
    if (capacity) {
      if (value >= 90) return classesRef.indicatorAmber;
      if (value > 49) return classesRef.indicatorYellow;
      return classesRef.indicatorGreen;
    }

    if (value >= 90) return classesRef.indicatorRed;
    if (value > 49) return classesRef.indicatorYellow;
    return classesRef.indicatorGreen;
  };

  const valueFormatted = clamp(value);
  const colorClass = usePercentColor(valueFormatted, classes, isCapacity);

  const isCritical = Number(value ?? 0) >= 100;

  return (
    <div
      className={clsx(classes.indicatorRow, {
        [classes.indicatorRowEnv]: isEnv,
      })}
      title={`${valueFormatted}%`}
    >
      <div
        className={clsx(classes.indicatorTrack, {
          [classes.indicatorTrackEnv]: isEnv,
        })}
      >
        <div
          className={`${classes.indicatorBar} ${colorClass}`}
          style={{ width: `${valueFormatted}%` }}
        />
      </div>

      <span
        className={clsx(classes.indicatorLabel, {
          [classes.indicatorLabelRed]: isCritical,
        })}
      >
        {valueFormatted}%
      </span>
    </div>
  );
};

export default PercentIndicator;
